import React, { CSSProperties } from 'react';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

import { Modal } from '@/components';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  isHoveringSensitive?: boolean;
  title?: string;
  children: React.ReactNode;
  testId?: string;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
  hideCloseButton?: boolean;
  titleBoxStyle?: CSSProperties;
  isClosingByClickOutsideBlocked?: boolean;
  isFullScreen?: boolean;
  contentMobileStyle?: React.CSSProperties;
}
const ModalWrapper: React.FC<Props> = ({
  title,
  children,
  onSetVisible,
  isHoveringSensitive,
  visible,
  testId,
  style,
  contentStyle,
  hideCloseButton,
  titleBoxStyle,
  isClosingByClickOutsideBlocked,
  isFullScreen,
  contentMobileStyle,
}) => {
  const { isMobile } = useResponsive();

  return (
    <Modal
      isHoveringSensitive={isHoveringSensitive}
      visible={visible}
      testId={testId}
      onSetVisible={onSetVisible}
      data-testid="ModalWrapper"
      wrapperStyle={style}
      contentStyle={contentStyle}
      contentMobileStyle={contentMobileStyle}
      isCloseButtonHidden={hideCloseButton}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked}
      isFullScreen={isFullScreen}
    >
      <Box direction="column">
        {title && (
          <Box
            direction="row"
            align="center"
            justify="center"
            pad={
              isMobile
                ? { bottom: 'spacing12', horizontal: 'spacing24' }
                : { bottom: 'spacing24', horizontal: 'spacing24' }
            }
            style={titleBoxStyle}
          >
            <Text
              size={isMobile ? 'xxlarge' : '2xl'}
              color="textBody"
              weight="bold"
              margin={isMobile ? { horizontal: 'spacing8' } : undefined}
              textAlign="center"
              style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {title}
            </Text>
          </Box>
        )}
        <Box>
          <Box>{children}</Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default ModalWrapper;
